// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__f1d7j","location":"Header_location__1BEGH"};